<template>
    <div class="o-invoices">
        <m-title title="Twoje faktury" />
        <template v-if="invoiceListIsLoading">
            <a-icon icon="Spinner" />
        </template>
        <template v-if="!invoiceListIsLoading && !invoiceList">
            <p class="a-title a-title--primary a-title--centered">
                Brak faktur do wyświetlenia
            </p>
        </template>
        <div v-else class="l-row o-invoices__list">
            <div
                v-for="invoice in invoiceList"
                :key="invoice.id"
                class="m-card o-invoices__listItem"
            >
                <div class="m-card__container m-card__wrapper">
                    <div class="m-card__row o-invoices__row">
                        <div class="m-card__column">
                            <p class="a-text a-text--bold a-text--bigger">
                                FV/{{ invoice.invoice_no }}
                            </p>
                        </div>
                        <div class="m-card__column m-card__column--centered">
                            <p
                                class="a-text a-text--small a-text--bold a-text--primary a-text--uppercase"
                            >
                                pakiet {{ invoice.bundle_name }}
                            </p>
                        </div>
                    </div>
                    <div class="m-card__row">
                        <div class="m-card__column">
                            <p class="a-text">
                                {{ invoice.payment_date }}
                            </p>
                        </div>
                        <div class="m-card__column">
                            <div class="m-card__row">
                                <div class="m-card__column">
                                    <p class="a-text">
                                        <span class="a-text--bold">{{
                                            $dayjs(invoice.active_to).diff(
                                                $dayjs(invoice.active_from),
                                                'month'
                                            )
                                        }}</span>
                                        mies.
                                    </p>
                                </div>
                                <div class="m-card__column">
                                    <p class="a-text">
                                        <span class="a-text--bold">{{
                                            invoice.total_value_gross
                                        }}</span>
                                        zł
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div
                        @click="toggleActiveMenuId(invoice)"
                        class="m-card__menu"
                    >
                        <a-icon icon="MenuDots" class="m-card__menuIcon" />
                        <transition name="fade">
                            <div
                                v-if="activeMenuId === invoice.id"
                                class="m-card__menuList"
                            >
                                <div class="m-card__menuListItem">
                                    <a
                                        class="a-text m-card__menuText"
                                        download="test_pobierz"
                                        :href="`${invoice.link}.pdf`"
                                        ><a-icon
                                            class="m-card__menuListIcon"
                                            icon="Download"
                                        />Pobierz fakturę</a
                                    >
                                </div>
                            </div>
                        </transition>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            activeMenuId: 0
        }
    },
    computed: {
        invoiceList() {
            return this.$store.getters['invoices/invoiceList']
        },
        invoiceListIsLoading() {
            return this.$store.getters['invoices/isLoading']
        }
    },
    methods: {
        toggleActiveMenuId(invoice) {
            if (this.activeMenuId === invoice.id) {
                this.activeMenuId = 0
            } else {
                this.activeMenuId = invoice.id
            }
        }
    },
    created() {
        this.$store.dispatch('invoices/fetchInvoices')
    }
}
</script>
